module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row upper-subpanel"
  }, [_c('progressBar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.stage === 'loading') ? _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [_c('Loader')], 1) : _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.returnCmpn !== null) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "upper-subpanel--half"
  }, [_c('h3', [_vm._v("目前設定位置")]), _vm._v(" "), _c('p', [_vm._v("\n                第 " + _vm._s(_vm.returnCmpn.net.open_times) + " 藥櫃 - 第 " + _vm._s(_vm.returnCmpn.net.row_id) + " 層 - 第 " + _vm._s(_vm.returnCmpn.pos_row) + " 列 - 第 " + _vm._s(_vm.returnCmpn.relative_col) + " 行\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.deleteReturnCmpn
    }
  }, [_vm._v("刪除退藥盒")])])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('selectBox', {
    attrs: {
      "mode": 'emptyAndF',
      "singleSelect": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "upper-subpanel--half"
  }, [_c('h3', [_vm._v("請在左側點選未使用藥盒")]), _vm._v(" "), _c('h3', [_vm._v("以設定退藥盒")])])])])])])], 1), _vm._v(" "), _c('bottom-buttons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), _vm._v(" "), (_vm.returnCmpn === null) ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "設定完成"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f2ca792","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SetReturnBox.vue
// module id = 1505
// module chunks = 1